export default "__VITE_ASSET__2a80b4ad__"